/**
 * Component Loader
 *
 * Usage in HTML:
 *   <div data-component="navbar"></div>
 *   <div data-component="footer"></div>
 *
 * Fetches src/components/<name>.html and replaces the placeholder element with
 * the loaded HTML. After all components are injected it fires:
 *
 *   document.dispatchEvent(new CustomEvent('components:ready'))
 *
 * Any script that needs component elements should listen for this event:
 *   document.addEventListener('components:ready', () => { ... });
 */

(function (): void {
    const placeholders = document.querySelectorAll<HTMLElement>('[data-component]');
    let pending: number = placeholders.length;

    if (pending === 0) {
        document.dispatchEvent(new CustomEvent('components:ready'));
        return;
    }

    placeholders.forEach(function (el: HTMLElement): void {
        const name = el.getAttribute('data-component') as string;

        fetch(`src/components/${name}.html`)
            .then(function (res: Response): Promise<string> {
                if (!res.ok) {
                    throw new Error(`Component "${name}" not found (${res.status})`);
                }
                return res.text();
            })
            .then(function (html: string): void {
                el.insertAdjacentHTML('beforebegin', html);
                el.remove();
            })
            .catch(function (err: unknown): void {
                console.error('[component-loader]', err);
            })
            .finally(function (): void {
                pending--;
                if (pending === 0) {
                    document.dispatchEvent(new CustomEvent('components:ready'));
                }
            });
    });
})();
